import React, { useState } from 'react';

import ProfileBannerModal from '../modals/ProfileBannerModal';
import { myProfile } from '../signals/profile';
import { Spinner } from 'react-bootstrap';

const MyProfileBanner = () => {
  const [showProfileBannerModal, setShowProfileBannerModal] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false); // State to track image loading

  return (
    <div>
      <div className="card border-0 w-100">
        {!isLoaded && (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              margin: 10,
              borderRadius: 10,
              maxHeight: 250,
              backgroundColor: '#f0f0f0',
              height: 250,
            }}
          >
            <Spinner
              animation="border"
              role="status"
              className="text-warning align-self-center"
            />
          </div>
        )}
        <img
          src={
            !myProfile.value.profile.cover
              ? 'assets/images/banner-1200x250.png'
              : myProfile.value.profile.cover
          }
          alt="avatar"
          style={{
            margin: 10,
            borderRadius: 10,
            maxHeight: 250,
            cursor: 'pointer',
            display: isLoaded ? 'block' : 'none', // Hide image until loaded
          }}
          onLoad={() => setIsLoaded(true)} // Set isLoaded to true when the image loads
          onClick={() => {
            setShowProfileBannerModal(true);
          }}
        />
      </div>
      <ProfileBannerModal
        isVisible={showProfileBannerModal}
        onClose={() => setShowProfileBannerModal(false)}
        onSave={(banner: any) => {
          setShowProfileBannerModal(false);
        }}
      />
    </div>
  );
};

export default MyProfileBanner;
